import React from "react";
import { company } from "../mock";
import PageHero from "../components/PageHero";

const sections = [
  { h: "1. Agreement", p: [`These Terms & Conditions govern your use of the ${company.name} website and services. By requesting a site visit or using our machines, you agree to these terms.`] },
  { h: "2. Eligibility", p: ["Free machine installation is offered to qualifying sites, typically workplaces with 30 or more staff or steady foot traffic. Eligibility is confirmed during a free site visit and is at our discretion based on location, access and expected usage."] },
  { h: "3. Installation & servicing", p: ["We deliver, install, stock and maintain the machine at no cost for qualifying sites. This includes routine restocking, cleaning and technical maintenance. You agree to provide safe access and a standard power point for the machine."] },
  { h: "4. Ownership", p: ["All machines remain the property of Elite Vending unless otherwise agreed in writing. You agree not to move, modify or service the machine yourself."] },
  { h: "5. Trial & removal", p: ["Where a trial applies, you may request removal within the trial period with no penalty. If a machine is under-used or a site no longer qualifies, we may remove it with reasonable notice."] },
  { h: "6. No lock-in contracts", p: ["We operate without lock-in contracts. Either party may end the arrangement with reasonable notice, and we will collect the machine promptly."] },
  { h: "7. Liability", p: ["We are not liable for indirect or consequential loss arising from the use of a machine, except where required by law. Product allergen and nutritional information is provided by manufacturers."] },
  { h: "8. Changes", p: [`We may update these terms from time to time. The latest version will always be available on this page. Questions? Contact ${company.email}.`] }
];

export default function Terms() {
  return (
    <main>
      <PageHero eyebrow="Legal" title="Terms & Conditions" subtitle="The terms that apply to our services and machines." />
      <section className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm text-muted-foreground">Last updated: July 2025</p>
          <div className="mt-8 space-y-8">
            {sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-xl text-ink">{s.h}</h2>
                {s.p.map((para, i) => (
                  <p key={i} className="mt-3 text-[15px] text-muted-foreground leading-relaxed">{para}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
